import React from "react"
import "./App.css"
import Home from "./Pages/Home"
import About from "./Pages/About"
import Services from "./Pages/Services"
import FixedImage from "./Pages/FixedImage"
import Work from "./Pages/Work"
import Contact from "./Pages/Contact"
import Footer from "./Components/Footer"
import { Lines } from "react-preloaders"

function App() {
  return (
    <>
      <div>
        <Home />
        <About />
        <Services />
        <FixedImage />
        <Work />
        <Contact />
        <Footer />
      </div>
      <Lines color={"#296d98"} />
    </>
  )
}

export default App
